import type { AnchorHTMLAttributes, MouseEvent, ReactElement } from "react";
import { navigate, withEditionQuery } from "../lib/router";

/** In-app link: plain <a href> (works without JS, middle-click, copy) with client-side navigation. */
export function Link({ href, onClick, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }): ReactElement {
  const handle = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(href);
  };
  return <a href={withEditionQuery(href)} onClick={handle} {...rest} />;
}
